import { isProxy, toRaw } from "vue";
import flatten from "./flatten.js";

async function downloadCsv(data, fileName, language) {
  if (isProxy(data)) {
    const items = toRaw(data);

    //Check if the object is valid
    if (
      !Array.isArray(items) ||
      !items.every((p) => typeof p === "object" && p !== null)
    ) {
      return;
    }
    var flatItems = [];
    items.forEach((item) => {
      delete item.cargo;
      delete item.showDetail;
      const flat = flatten(item);
      flatItems.push(flat);
    });

    //Translate the heading items
    var headingKeys = [];
    Object.keys(flatItems[0]).forEach(element => {
      headingKeys.push(language[element]);
    });

    //Construting CSV
    let heading = headingKeys.join(";");
    heading = heading + ";\n";
    const body = flatItems.map((j) => Object.values(j).join(";")).join("\n");

    var csv = `${heading}${body}`;
    var blob = new Blob(["\uFEFF" + csv], {
      type: "text/csv; charset=utf-18",
    });

    let link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = language[fileName].replace(" ", "_") + ".csv";
    link.click();
  }
}
export default downloadCsv
